/*
 * @Description: 描述...
 * @Author: LiuYongChun
 * @Date: 2020-12-03 14:11:46
 * @LastEditors: LiuYongChun
 * @LastEditTime: 2021-01-04 11:04:52
 */
import fetch from './index';
import { IPAGE } from '@/types/base.d';

// 题库管理 start
// 添加题库
const addQuesBank = (params: object) => fetch.axios_admin.post('/subject', params);

// 修改题库
const modifyQuesBank = (params: object) => fetch.axios_admin.patch('/subject', params);

// 删除题库
const removeQuesBank = (id: string) => fetch.axios_admin.put(`/subject?id=${id}`);

// 恢复题库
const restoreQuesBank = (id: string) => fetch.axios_admin.put(`/subject?id=${id}`);

// 题库详情
const quesBankDetail = (id: string) => fetch.axios_admin.get(`/exam_question/subjectId?sid=${id}`);

// 分页获取所有题库
const pageGetQuesBank = (params: IPAGE) => fetch.axios_admin.get('subject?sort=createAt,DESC', { params });
// 题库管理 end

// 试题管理 start
// 添加试题
const addTestQues = (params: object) => fetch.axios_admin.post(`exam_question`, params);

// 修改试题
const modifyTestQues = (params: object) => fetch.axios_admin.patch(`exam_question`, params);

// 删除试题
const removeTestQues = (id: string) => fetch.axios_admin.remove(`/exam_question?id=${id}`);

// 检测试题是否已使用
const checkTestQues = (id: string) => fetch.axios_admin.get(`/exam_question/usage?id=${id}`);

// 试题检索
const searchTestQues = (params: any) => fetch.axios_admin.get(`/exam_question/?knowledge=${params.knowledge}&subjectId=${params.subjectId}&type=${params.type}&serial=${params.serial}`);

//分页获取所有试题
const pageGetTestQues = (params: IPAGE) => fetch.axios_admin.get('exam_question?&sort=createAt,DESC', { params });

// 查询所有题库
const getAllQuesBank = () => fetch.axios_admin.get('/subject/name');

// 获取试题的详细信息
const getQuesDetail = (id: string) => fetch.axios_admin.get(`/exam_question/content?id=${id}`);

// 试题管理 end

// 试卷管理 start
// 添加试卷
const addTestPaper = (params: object) => fetch.axios_admin.post(`/exam_paper`, params);

// 根据id获取试卷详细信息
const getTestPaperById = (id: string) => fetch.axios_admin.get(`/exam_paper/content?id=${id}`)

// 根据id获取题库详细信息
const getQuesDetailCount = (id: string) => fetch.axios_admin.get(`/subject/details?id=${id}`)

// 修改试卷
const modifyTestPaper = (params: object) => fetch.axios_admin.patch(`/exam_paper`, params);

// 删除试卷
const removeTestPaper = (id: string) => fetch.axios_admin.remove(`exam_paper?id=${id}`);

// 根据id获取试卷详细信息
const getpaperDetailCount = (id: string) => fetch.axios_admin.get(`/exam_paper/details?id=${id}`)

// 分页获取所有试卷
const pageGetTestPaper = (params: IPAGE) => fetch.axios_admin.get(`exam_paper?sort=createAt,DESC`, { params });

// 试卷管理 end

// 考试管理 start
// 添加考试
const addTest = (params: object) => fetch.axios_admin.post(`/exam`, params);

// 修改考试
const modifyTest = (params: object) => fetch.axios_admin.patch(`/exam`, params);

// 删除考试
const removeTest = (id: string) => fetch.axios_admin.remove(`/exam?id=${id}`);

// 分页查询所有考试
const pageGetTest = (params: IPAGE) => fetch.axios_admin.get(`/exam?pageNo=${params.pageNo}&pageSize=${params.pageSize}&sort=createAt,DESC`);

// 查找所有试卷
const getAllTestPaper = () => fetch.axios_admin.get('/exam_paper/name');

// 考试管理 end

export default {
    getTestPaperById,
    addQuesBank,
    modifyQuesBank,
    removeQuesBank,
    pageGetQuesBank,
    addTestQues,
    modifyTestQues,
    removeTestQues,
    pageGetTestQues,
    getQuesDetailCount,
    addTestPaper,
    modifyTestPaper,
    removeTestPaper,
    pageGetTestPaper,
    addTest,
    modifyTest,
    removeTest,
    pageGetTest,
    getAllQuesBank,
    getAllTestPaper,
    getQuesDetail,
    checkTestQues,
    restoreQuesBank,
    searchTestQues,
    getpaperDetailCount,
    quesBankDetail,
}
